const ourRecharge = (id, payload) => {
  return {
    'id': id,
    'hero': payload.hero,
    'heroTop': payload.heroTop,
    'heroH1': payload.heroH1,
    'heroH2': payload.heroH2,
    'heroCta': payload.heroCta,
    'promoHero': payload.promoHero,
    'promoHeroTop': payload.promoHeroTop,
    'promoHeroH1': payload.promoHeroH1,
    'promoHeroH2': payload.promoHeroH2,
    'promoHeroCta': payload.promoHeroCta,
    'promoHeroFineprint': payload.promoHeroFineprint,
    'prebookHero': payload.prebookHero,
    'prebookHeroTop': payload.prebookHeroTop,
    'prebookHeroH1': payload.prebookHeroH1,
    'prebookHeroH2': payload.prebookHeroH2,
    'prebookHeroCta': payload.prebookHeroCta,
    'prebookHeroFineprint': payload.prebookHeroFineprint
  }
}

const ourRechargeWelcomeOffer = (id, payload) => {
  return {
    'id': id,
    'hero': payload.hero,
    'heroTop': payload.heroTop,
    'heroH1': payload.heroH1,
    'heroH2': payload.heroH2,
    'rechargeText': payload.rechargeText,
    'promoHero': payload.promoHero,
    'promoHeroTop': payload.promoHeroTop,
    'promoHeroH1': payload.promoHeroH1,
    'promoHeroH2': payload.promoHeroH2,
    'promoRechargeText': payload.promoRechargeText,
    'promoHeroFineprint': payload.promoHeroFineprint,
    'prebookHero': payload.prebookHero,
    'prebookHeroTop': payload.prebookHeroTop,
    'prebookHeroH1': payload.prebookHeroH1,
    'prebookHeroH2': payload.prebookHeroH2,
    'prebookRechargeText': payload.prebookRechargeText,
    'prebookHeroFineprint': payload.prebookHeroFineprint
  }
}

const ourPhoneCode = (id, payload) => {
  return {
    'id': id,
    'pageTitle': payload.pageTitle,
    'pageDescription': payload.pageDescription,
    'keywords': payload.keywords,
    'countryName': payload.countryName,
    'bodyTitle': payload.bodyTitle,
    'body': payload.body,
    'overrideh1': payload.overrideh1 !== undefined ? payload.overrideh1 : ''
  }
}

const ourArticle = (id, payload) => {
  return {
    'id': id,
    'pageTitle': payload.pageTitle,
    'pageDescription': payload.pageDescription,
    'keywords': payload.keywords !== undefined ? payload.keywords : null,
    'locale': payload.locale,
    'category': payload.category,
    'url': payload.url,
    'bodyTitle': payload.bodyTitle,
    'leadText': payload.leadText,
    'body': payload.body,
    'imageUrl': payload.imageUrl,
    'publishedDate': payload.publishedDate !== undefined ? new Date(payload.publishedDate) : null,
    'noIndex': payload.noIndex !== undefined ? payload.noIndex : false
  }
}

export {
  ourRecharge,
  ourPhoneCode,
  ourArticle,
  ourRechargeWelcomeOffer
}



// WEBPACK FOOTER //
// ./src/api/webcontent/translator.js